/**
 * @module KMap/Info
 * @description api基本信息
 */

/**
 * @const
 * @version
 * @type {string}
 * @description 版本
 */
export const version = "KMap 1.0 Base On OpenLayers6.14.1"

/**
 * @const
 * @type {string}
 * @description 原生引擎名称
 */
export const srcApiName = "OpenLayers6.14.1"
